module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2c10cf17.png";